import React from 'react';
import * as styles from './Header.scss';

interface MenuSection {
    boldTitle: string;
    subtitle?: string;
    text?: string;
}

const MenuSection: React.FC<MenuSection> = ({ boldTitle, subtitle, text }) => {
    return (
        <div>
            <div>{boldTitle}</div>
            <div className={styles.profileInfoContainer}>
                {subtitle && <div>{subtitle}</div>}
                {text && <div>{text}</div>}
            </div>
        </div>
    );
};

export default MenuSection;
